import React from 'react'
import { Helmet } from "react-helmet";
import './SiteMap.scss';
import AreaData from '../../Components/ServicesPage/AreaData'
import CityList from '../../Components/HomePageCity/CitiesData'

export default function SiteMap({ CitiePhone, Blogs = [], FaqList = [] }) {
    return (
        <div className="SiteMap">
            <Helmet>
                <title>Site Map | BHO Chimney Sweep | 866-501-1614</title>
                <meta name="title" property="title" content="Site Map | BHO Chimney Sweep" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Site Map | BHO Chimney Sweep" data-react-helmet="true" />
                <meta name="description" content="Browse every page on BHO Chimney Sweep — services, city pages, blog, FAQ, contact and more." data-react-helmet="true" />
                <meta name="og:url" property="og:url" content="https://www.bhochimneysweep.com/sitemap" />
                <link rel="canonical" href="https://www.bhochimneysweep.com/sitemap" />
                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className="SiteMapHero">
                <h1>BHO Chimney Sweep — Site Map</h1>
                <p>A directory of every page on bhochimneysweep.com. Call <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> for service.</p>
            </div>

            <div className="SiteMapGrid">
                <section className="SiteMapSection">
                    <h2>Main Pages</h2>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li><a href="/services">All Services</a></li>
                        <li><a href="/contact">Contact</a></li>
                        <li><a href="/book">Book an Appointment</a></li>
                        <li><a href="/reviews">Customer Reviews</a></li>
                        <li><a href="/blog">Blog</a></li>
                        <li><a href="/faq">FAQ</a></li>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                        <li><a href="/terms-and-conditions">Terms &amp; Conditions</a></li>
                    </ul>
                </section>

                <section className="SiteMapSection">
                    <h2>Local Landing Pages</h2>
                    <ul>
                        <li><a href="/local">Local Service Area</a></li>
                        <li><a href="/local/chimney">Chimney Local Landing</a></li>
                        <li><a href="/local/airduct">Air Duct Local Landing</a></li>
                    </ul>
                </section>

                <section className="SiteMapSection SiteMapSectionWide">
                    <h2>Services ({AreaData.length})</h2>
                    <ul className="SiteMapColumns">
                        {AreaData.map((A, i) => (
                            <li key={i}><a href={A.Path}>{A.Title}</a></li>
                        ))}
                    </ul>
                </section>

                {Blogs && Blogs.length > 0 && (
                    <section className="SiteMapSection SiteMapSectionWide">
                        <h2>Blog ({Blogs.length})</h2>
                        <ul className="SiteMapColumns">
                            {Blogs.map((B, i) => (
                                <li key={i}><a href={`/blog/${B.BlogPath.replace(/ /g, "_") + "_" + (B.BlogId - 1)}`}>{B.Title}</a></li>
                            ))}
                        </ul>
                    </section>
                )}

                {FaqList && FaqList.length > 0 && (
                    <section className="SiteMapSection SiteMapSectionWide">
                        <h2>FAQ ({FaqList.length})</h2>
                        <ul className="SiteMapColumns">
                            {FaqList.map((F, i) => (
                                <li key={i}><a href={`/faq/${F.questionPath.replace(/ /g, "_") + "_" + (F.faqId - 1)}`}>{F.question}</a></li>
                            ))}
                        </ul>
                    </section>
                )}

                <section className="SiteMapSection SiteMapSectionWide">
                    <h2>Service Areas ({CityList.length} cities)</h2>
                    <ul className="SiteMapColumns SiteMapColumnsCities">
                        {CityList.map((C, i) => (
                            <li key={i}><a href={`/city/${C.url}`}>{C.City}, {C.StateID}</a></li>
                        ))}
                    </ul>
                </section>
            </div>
        </div>
    )
}
